import { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useCurrentUser } from '@lingaai/user-management';
import { UserInfo } from './settings/UserInfo';
import { DataPrivacy } from './settings/DataPrivacy';
import { AuditLogs } from './settings/AuditLogs';
import { TenantInfo } from './settings/TenantInfo';
import { UserManagementTab } from './settings/UserManagementTab';

export function Settings() {
  const [activeTab, setActiveTab] = useState(0);
  const { data: user } = useCurrentUser();
  const isPortco = user?.role === 'portco';
  const isAdmin = user?.role && ['super_admin', 'admin', 'billing_admin'].includes(user.role);

  return (
    <Box sx={{ p: 3 }}>
      {isPortco ? (
        // Portco users only see their user info
        <UserInfo />
      ) : (
        // Admin/super_admin see all tabs
        <>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
            <Tabs value={activeTab} onChange={(_, newValue) => setActiveTab(newValue)}>
              <Tab label="User Info" />
              {isAdmin && <Tab label="User Management" />}
              <Tab label="Tenant Info" />
              <Tab label="Data & Privacy" />
              <Tab label="Audit Logs" />
            </Tabs>
          </Box>

          {activeTab === 0 && <UserInfo />}
          {isAdmin && activeTab === 1 && <UserManagementTab />}
          {activeTab === (isAdmin ? 2 : 1) && <TenantInfo />}
          {activeTab === (isAdmin ? 3 : 2) && <DataPrivacy />}
          {activeTab === (isAdmin ? 4 : 3) && <AuditLogs />}
        </>
      )}
    </Box>
  );
}
